import { render, staticRenderFns } from "./AddressHeader.vue?vue&type=template&id=0298256d&"
import script from "./AddressHeader.vue?vue&type=script&lang=js&"
export * from "./AddressHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports